import { X } from "lucide-react";
import { Input } from "../ui/input";

/**
 * Input with a built-in clear (X) button and mobile-friendly keyboard defaults.
 * Use for search/filter fields: the X clears the value explicitly, so dismissing the
 * soft keyboard never wipes the user's text.
 */
export function ClearableInput({ value, onChange, testid, className = "", ...props }) {
  return (
    <div className={`relative ${className}`}>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="none"
        spellCheck={false}
        enterKeyHint="search"
        className={value ? "pr-8" : ""}
        {...props}
      />
      {value ? (
        <button
          type="button"
          aria-label="Clear"
          data-testid={`${testid}-clear`}
          onClick={() => onChange("")}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
}
